import * as React from 'react';
import { Banner } from '@components/atoms';
import { Header, Footer } from '@components/molecules';

type Props = {
	title: string;
	subtitle?: string;
	submitButton: string;
	linkButton?: string;
	linkText?: string;
	isValid?: boolean;
	isLoading?: boolean;
	handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
	onLinkClick?: (e: React.MouseEvent<HTMLElement>) => void;
	error?: string;
};

export const SimpleLayout: React.FC<Props> = ({
	title,
	subtitle,
	linkButton,
	linkText,
	submitButton,
	handleSubmit,
	isValid,
	isLoading,
	onLinkClick,
	children,
	error,
}) => {
	return (
		<form className="flex flex-col gap-20" onSubmit={handleSubmit} data-testid="auth-simple-layout">
			<Header title={title} subtitle={subtitle} />
			<div className="flex flex-col justify-center gap-16">
				{error && <Banner title={error} variant="error" />}
				<main>{children}</main>
				<Footer
					onLinkClick={onLinkClick}
					linkText={linkText}
					linkButton={linkButton}
					submit={submitButton}
					isLoading={isLoading}
					disabled={!isValid}
				/>
			</div>
		</form>
	);
};
